module.exports = __webpack_public_path__ + "static/media/getcareer_main_2.31e8ebba.png";